import { render } from "./TerminalForm.vue?vue&type=template&id=1e8a8de8&scoped=true"
import script from "./TerminalForm.vue?vue&type=script&lang=js"
export * from "./TerminalForm.vue?vue&type=script&lang=js"

import "./TerminalForm.vue?vue&type=style&index=0&id=1e8a8de8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1e8a8de8"

export default script